import { render, staticRenderFns } from "./OrderEditDlg.vue?vue&type=template&id=a094b866&scoped=true"
import script from "./OrderEditDlg.vue?vue&type=script&lang=js"
export * from "./OrderEditDlg.vue?vue&type=script&lang=js"
import style0 from "./OrderEditDlg.vue?vue&type=style&index=0&id=a094b866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a094b866",
  null
  
)

export default component.exports